import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
var defaultOpts = {
  timeZone: 'UTC',
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric'
};
var dateToLocaleStr = function dateToLocaleStr(dateStr, opts) {
  return new Date(dateStr).toLocaleString('default', opts);
};
var timeRangeStr = function timeRangeStr(interviewTime) {
  // Validate that we have all required fields
  if (!interviewTime.date || !interviewTime.start_time || !interviewTime.end_time) {
    return 'Time not set';
  }
  var startStr = "".concat(interviewTime.date, " ").concat(interviewTime.start_time);
  var startMoment = moment(startStr, 'YYYY-MM-DD HH:mm');
  var endStr = "".concat(interviewTime.date, " ").concat(interviewTime.end_time);
  var endMoment = moment(endStr, 'YYYY-MM-DD HH:mm');

  // Check if moments are valid
  if (!startMoment.isValid() || !endMoment.isValid()) {
    return 'Invalid time';
  }
  return "".concat(startMoment.format('h:mma'), " - ").concat(endMoment.format('h:mma'));
};
function InterviewTimeRange(_ref) {
  var interviewTime = _ref.interviewTime,
    _ref$opts = _ref.opts,
    opts = _ref$opts === void 0 ? defaultOpts : _ref$opts,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa;
  console.log('InterviewTimeRange interviewTime:', interviewTime);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, dateToLocaleStr(interviewTime.date, opts), "\xA0 \xB7 \xA0", timeRangeStr(interviewTime));
}
InterviewTimeRange.propTypes = {
  interviewTime: PropTypes.shape({
    date: PropTypes.string.isRequired,
    start_time: PropTypes.string.isRequired,
    end_time: PropTypes.string.isRequired
  }).isRequired,
  opts: PropTypes.shape({}),
  containerClassName: PropTypes.string
};
InterviewTimeRange.defaultProps = {
  opts: defaultOpts,
  containerClassName: ''
};
export default InterviewTimeRange;